export default __webpack_public_path__ + "media/1a1b38cad96e7b1f6f1f38818d60ab0e140ddd0a343b7de10efff87754723ef3.svg";